import React from 'react';
import { Button, Modal } from "semantic-ui-react";

const ConfirmationPopup = (props) => (
    <Modal open={props.isShowConfirmation} closeOnDimmerClick={false} size='tiny'>
        <Modal.Header className="text-center">{props.confirmationHeader}</Modal.Header>
        <Modal.Content style={{ display: 'flex', justifyContent: 'center' }}>{props.confirmationMessage}</Modal.Content>
        <Modal.Actions className={`d-flex ${props.isShowYes ? "justify-content-between" : "justify-content-center"}`}>
            <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onClickCloseBtn}>{props.noText}</Button>
            {props.isShowYes &&
                <Button disabled={props.isBtnDisabled ?? false} secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickYesBtn}>{props.yesText}</Button>
            }
        </Modal.Actions>
    </Modal>
)

export default ConfirmationPopup;